lbaFareClassTypeSelectCtrl.$inject = ['$scope', '$routeParams', '$filter', 'fareClassTypeService', 'dataService'];
function lbaFareClassTypeSelectCtrl($scope, $routeParams, $filter, fareClassTypeService, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  vm.display = $filter(vm.settings.fareClassTypeFilter || 'fareClassType');
  vm.fareClassTypes = fareClassTypeService.get();

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });
}

export default lbaFareClassTypeSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaFareClassTypeSelect/lbaFareClassTypeSelectCtrl.js